import {
  MaterialUICore,
  axiomTokens,
  Body as DSBody,
  Box as DSBox,
} from '@iclinic/design-system';

const { styled } = MaterialUICore;

const { spacing } = axiomTokens;

export const ButtonContainer = styled(DSBox)({
  gap: spacing[4],
  justifyContent: 'center',
  display: 'flex',
});

export const Body = styled(DSBody)({
  letterSpacing: '0.44px',
  textAlign: 'center',
  marginBottom: spacing[3],
});

export const Box = styled(DSBox)({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  marginBottom: spacing[3],
});
